module.exports = __webpack_public_path__ + "static/media/industries.46ca3ed6.png";